import { types, flow, applySnapshot } from 'mobx-state-tree';
import { makeRequest } from 'js/services/Network';
import ActivityItem from '../types/ActivityItem';

export default types
  .model('UserDashboardPage', {
    num_tokens: types.maybe(types.number),
    num_items: types.maybe(types.number),
    store_value: types.maybe(types.number),
    user_balance: types.maybe(types.number),
    activity_today: types.array(ActivityItem),
    activity_older: types.array(ActivityItem),
    google_contact_emails: types.maybeNull(types.array(types.string)),
    creditModalIsVisible: false,
    earningsModalIsVisible: false,
    offersModalIsVisible: false,
    first_login: types.optional(types.boolean, false),
    has_address: types.optional(types.boolean, false),
    transactions: types.maybe(types.number),
    count_discount_users: types.maybe(types.number),
  })
  .actions(self => ({
    load: flow(function* load() {
      const response = yield makeRequest('user-dashboard-data', self);
      applySnapshot(self, response.data);
      return response;
    }),
    updateBalance(balance){
      self.user_balance = balance;
      return self;
    },
    showCreditModal(e) {
      e.preventDefault();
      self.creditModalIsVisible = true;
      return self;
    },
    closeCreditModal() {
      self.creditModalIsVisible = false;
      return self;
    },
    closeGoogleContactsModal(){
      self.google_contact_emails = null;
      return self;
    },
    setFirstLogin(first_login) {
      self.first_login = first_login;
      return self;
    },
    showOffersModal(e) {
      e.preventDefault();
      self.offersModalIsVisible = true;
      return self;
    },
    closeOffersModal() {
      self.offersModalIsVisible = false;
      return self;
    }
  }));
